<template>
    <div class="map-container relative">
        <img
            ref="mapImage"
            src="/img/map/map4.jpg"
            alt="Carte"
            class="map-image rounded-2xl"
        />
        <!-- Overlays -->
        <transition-group name="fade" tag="div" class="absolute inset-0">
            <img
                v-for="num in images"
                :key="num"
                :src="`/img/map/map${num}.jpg`"
                alt=""
                :id="`map-overlay-${num}`"
                class="absolute top-0 left-0 w-full h-auto object-cover"
                :style="`z-index: ${10-num}`"
            />
        </transition-group>
    </div>
    <div class="flex justify-center mt-4">
  <span
      class="inline-block bg-orange-100 bg-opacity-20 text-gray-600 text-xs px-3 py-1 rounded-full shadow-sm"
  >
    Attention à bien orienter la carte !
  </span>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios';

// on déclare la prop br (nombre d'images)
const props = defineProps({
    br: {
        type: Number,
        required: true
    }
})

// tableau des indices d'images à afficher
const images = ref([0,1,2,3])
const steps = ref([])
const unlockedStep = ref(0)
const currentStep = ref({})
const emit = defineEmits({
    'set-blink-map': (value) => typeof value === 'boolean'
})

onMounted(async() => {

    const { data } = await axios.get('/api/steps')
    steps.value = data

    emit('set-blink-map', false)

    // lecture du dernier pas débloqué (nombre entier)
    const stored = localStorage.getItem('unlockedStep')
    unlockedStep.value = stored ? parseInt(stored, 10) : 0

    let unlockedMap = localStorage.getItem('unlockedMap') || 0;

    let shownMap=localStorage.getItem('shownMap') || 0;


    // on affiche les images en fonction de l'étape débloquée
    //check number of map to fade out with 6sec timer for first discover map
    //TEST ci dessous !!
    //shownMap=0;
    //unlockedMap=4;

    //affiche directement les images déjà affichées en utilisant la class fade-no-transition
    for (let i = 0; i < shownMap; i++) {
        document.getElementById(`map-overlay-${i}`).classList.add('fade-no-transition');
        images.value.shift();
    }

    // on affiche les images de la carte petit à petit avec un fadeout opacity 6s
    let nbToFadeOut = unlockedMap - shownMap;

    console.log(`Dévoile ${nbToFadeOut} brouillard(s)`);

    for (let i = 0; i < nbToFadeOut; i++) {
        setTimeout(() => {
            images.value.shift()
            console.log(`Dévoile brouillard ! i: ${i}`);
        }, 2500*i); // 3 secondes entre chaque overlay non dévoilé
    }
    localStorage.setItem('shownMap', unlockedMap);


})
</script>

<style scoped>
.map-container {
    position: relative;
    width: 100%;
    aspect-ratio: 1024 / 1536;
    max-width: 100%;
    margin: 0 auto;
    overflow: hidden;
}
.map-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}
/* Fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 6s linear;
}
.fade-no-transition {
    transition: none !important;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
